<template>
  <div header>
    <header>
      <h1><router-link :to="`/${site}/committee`">KS 인증시스템</router-link></h1>
      <div class="nav">
        <div class="wrapper">
          <div class="util" v-if="authentication">
            <p>{{ authentication.role | charge }} <em>{{ authentication.name }}</em> {{ authentication.grade }}</p>
            <router-link :to="`/${site}/committee/userInfo`">개인정보관리</router-link>
            <a href="/logout">로그아웃</a>
          </div>
          <div class="util" v-else>
            <router-link :to="`/${site}/committee/login`">로그인</router-link>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<style lang="less">
 @import "../../../less/vars";
 @import "../../../less/asset";

  [header] { .rel; height:63px; z-index:99;
    header { .rel; background:#2f3541; .-b(#ccc); height:63px; overflow:hidden; transition:height .3s;
      h1 { .rel; .wh(1200,63); .mh-c; a { .block; .abs; .lt(0,13); .ir; .wh(162,45); .bg('@{admin}/logo.png'); .no-repeat; } }
      .nav { .rel; background:#464d5d; .-b(#2f3541); z-index:9;
        &:before { .cnt; .abs; .lt; .wh(100%,1px); background:#fff; opacity:.1; }
        nav {
          .d1 { .ib-list; }
          .d1 > li { .rel;
            > a { .block; .fs(14,2); .h(46); .tc; color:#fff; .bold; .p(0,25);
              span { .ib; .mt(9); }
              &.router-link-active { background:#2a2e38; span { .-b(@c-red,2px); } }
            }
            &:hover > a { background:#2a2e38; span { .-b(@c-red,2px); }}
          }
        }
        .util { .abs; .rt(0,-30);
          p { .ib; color:#fff; .fs(15); .mr(20); em { color:#dd4250; }}
          a { color:#fff; .ml(10); }
        }
      }
    }
  }
</style>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// src/views/committee/common/AppHeader.vue